import React, { useState, useEffect } from 'react';
import { Snackbar, Alert, Slide, Typography } from '@mui/material';

function SlideTransition(props) {
  return <Slide {...props} direction="down" />;
}

const formatMessage = (text) => {
  if (!text) return null;
  // Разделяем по \n
  const lines = text.split('\\n');
  return lines.map((line, index) => (
    <React.Fragment key={index}>
      {line}
      {index < lines.length - 1 && <br />}
    </React.Fragment>
  ));
};

const NotificationSnackbar = ({ 
  open, 
  message, 
  severity = 'error', // 'error', 'success', 'warning', 'info'
  duration = 4000,
  onClose 
}) => {
  const [isOpen, setIsOpen] = useState(open);

  useEffect(() => {
    setIsOpen(open);
    
    if (open && duration > 0) {
      const timer = setTimeout(() => {
        handleClose();
      }, duration);
      
      return () => clearTimeout(timer);
    }
  }, [open, duration]);

  const handleClose = () => {
    setIsOpen(false);
    if (onClose) onClose();
  };

  return (
    <Snackbar
      open={isOpen}
      autoHideDuration={duration}
      onClose={handleClose}
      TransitionComponent={SlideTransition}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      sx={{
        '& .MuiSnackbarContent-root': {
          width: 'auto',
          minWidth: '300px'
        }
      }}
    >
      <Alert 
        onClose={handleClose} 
        severity={severity}
        variant="filled"
        sx={{ width: '100%', borderRadius: '0.5rem' }}
      >
        <Typography
          sx={{
            fontSize: {xs: '0.8rem', md: '0.95rem'}
          }}
        >
          {formatMessage(message)}
        </Typography>        
      </Alert>
    </Snackbar>
  );
};

export default NotificationSnackbar;